import React, { useEffect } from "react";
import NavbarClass from "../NavbarClass";
import { activateUser } from "../../actions/userActions";
import { connect } from "react-redux";
// import { Jumbotron } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";


class EmailActivation extends React.Component {
  // componentDidMount(){
  //   const token = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).token
  componentDidMount() {
    const token = this.props.match.params.token;
    this.props.activateUser(token);
  }
  render() {
    return (
      <div>
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.userLogin.loading,
    error: state.userLogin.error,
  };
};
export default connect(mapStateToProps, { activateUser })(EmailActivation);
